import { type DependencyList, useEffect } from 'react';

import Socket from '../socket';

export function useSocketSubscription(
  socket: Socket | undefined,
  subscribe: (socket: Socket) => (() => void) | void,
  deps: DependencyList,
): void {
  useEffect(() => {
    if (!socket) return;
    const cleanup = subscribe(socket);
    return typeof cleanup === 'function' ? cleanup : undefined;
  }, [socket, ...deps]);
}
